


























































































import { Component, Vue } from 'vue-property-decorator';
import InfoLink from '@/components/InfoLink.vue';
import Phone from '@/components/Phone.vue';
@Component({
  components: {
    InfoLink,
    Phone,
  },
})
export default class Logo extends Vue {}
